import React from 'react';

type AlertProps = {
    type: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';
    icon?: string;
    message: string;
    isDismissable?: boolean;
    dismiss?: () => void;
    heading?: string;
};

export const Alert: React.FunctionComponent<AlertProps> = ({
                                                               type,
                                                               message,
                                                               icon,
                                                               isDismissable = false,
                                                               dismiss,
                                                               heading = '',
                                                           }) => {

    const alertClasses = [
        'alert',
        'alert-' + type
    ].join(' ');

    return (
        <div className={alertClasses}>
            {heading && <h4 className="alert-heading">{heading}</h4>}
            <div className="d-flex flex-row align-items-start">
                {icon && <i className={`align-self-center far fa-${icon}`}></i>}
                <span className="align-self-center ml-1 flex-fill flex-grow-1">{message}</span>

                {isDismissable && dismiss &&
                <button type="button"
                        className="close"
                        aria-label="Close"
                        onClick={dismiss}
                ><span aria-hidden="true">&times;</span></button>
                }
            </div>
        </div>
    );
};